import React from 'react';
import { Button } from '../ui/Button';
export function CTASection() {
  return <section className="py-24 bg-slate-50" data-id="element-317">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center" data-id="element-318">
        <h2 className="text-3xl md:text-5xl font-bold text-[#1a2332] mb-6" data-id="element-319">
          Experience Our Training Firsthand
        </h2>

        <p className="text-lg text-slate-600 mb-10 max-w-2xl mx-auto" data-id="element-320">
          The best way to understand our approach is to experience it yourself.
          No pressure, no commitment—just an opportunity to see if we're the
          right fit for you.
        </p>

        <div className="bg-[#1a2332] rounded-2xl p-8 md:p-12 shadow-xl text-white" data-id="element-321">
          <h3 className="text-2xl md:text-3xl font-bold mb-4" data-id="element-322">
            Get 2 Weeks Free
          </h3>

          <p className="text-slate-300 text-lg mb-8 max-w-2xl mx-auto" data-id="element-323">
            Full access to our beginner classes, a uniform consultation, and a
            personal introduction to our school. Come see what structured
            martial arts training can do for you.
          </p>

          <Button variant="primary" size="lg" className="w-full sm:w-auto text-lg px-12 py-4 h-auto bg-[#dc2626] hover:bg-[#b91c1c] border-transparent" data-id="element-324">
            Get 2 Weeks Free
          </Button>
        </div>
      </div>
    </section>;
}